import React, { useEffect, useState } from "react";
import ProgressOr from "../../../../components/ProgressOr/ProgressOr";
import { TextField, Grid, Box, IconButton } from "@material-ui/core";
import { SaveAlt } from "@material-ui/icons";
import TypeSelector from "./TypeSelector";
import DataTable from "../../../../components/DataTable/DataTable";
import Rest from "../../../../helpers/Rest";

const PROPS = {
    variant: "outlined",
    size: "small",
    fullWidth: true
}

function DatePicker({label, value, onChange}){
    return <Grid item xs={5} md={3}>
        <TextField
            {...PROPS}
            label={label}
            type="date"
            value={value}
            onChange={e => onChange(e.target.value)}
            InputLabelProps={{ shrink: true }}
        />
    </Grid> 
}

function addParam(search, key, value){
    if (/\S+/.test(value)) search.set(key, value);
}

function csvEscape(str){
    return `"${str.replace(/"/g, '""')}"`
}

function convertToCSV(data){
    return data.map(row => 
        `${row.id},${row.transaction_id},${row.timestamp},${csvEscape(row.info_type)},${csvEscape(row.message)},${csvEscape(JSON.stringify(row.diagnostics))}`
    ).join('\n');
}

function downloadCSV(data, ...other){
    other = other.map(part => /\S+/.test(part) ? '-' + part.replace(/[^a-zA-Z0-9]+/g, '_') : '').join('');
    const csv = `ID,Transaction,Time,Info Type,Message,Diagnostics\n${convertToCSV(data)}`;
    const blob = new Blob([csv], {type: 'text/csv'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `status_log${other}.csv`;
    a.click();
    URL.revokeObjectURL(url);
}

const DEFAULT_DATES = (() => {
    const now = new Date();
    now.setDate(now.getDate() + 1);
    const until = now.toISOString().split('T')[0];
    now.setDate(now.getDate() - 7);
    return [now.toISOString().split('T')[0], until];
})()

export default function({device}){
    const [fromDate, setFromDate] = useState(DEFAULT_DATES[0]);
    const [toDate, setToDate] = useState(DEFAULT_DATES[1]);
    const [search, setSearch] = useState('');
    const [results, setResults] = useState('');

    useEffect(() => {
        const params = new URLSearchParams();
        addParam(params, "from_date", fromDate);
        addParam(params, "to_date", toDate);
        addParam(params, "search", search);
        const query = params.size ? `?${params}` : "";
        Rest.get(`device/${device.id}/info/list${query}`).then(setResults).catch(console.error);
    }, [fromDate, toDate, search]);

    return <ProgressOr showProgress={!results} progressMessage={`Fetching status of ${device.name}...`}>
        <Grid container spacing={2} style={{marginTop: "8px"}}>
            <Grid item xs={5} sm={4} md={2}>
                <TypeSelector fullWidth />
            </Grid>
            <Grid item xs={7} sm={8} md={3}>
                <TextField
                    {...PROPS}
                    label="Search"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
            </Grid>
            <DatePicker label="From" value={fromDate} onChange={setFromDate} />
            <DatePicker label="Until" value={toDate} onChange={setToDate} />
            <Grid item xs={2} md={1}>
                <IconButton onClick={() => downloadCSV(results, device.code, fromDate, toDate, search)}>
                    <SaveAlt />
                </IconButton>
            </Grid>
            <Grid item xs={12}>
                <DataTable
                    data={results && results.map(result => [
                        result.timestamp,
                        result.transaction_id,
                        result.info_type,
                        result.message,
                        result.diagnostics
                    ]) || []}
                    options={{
                        search: false,
                        selectableRows: 'none',
                        rowsPerPage: 100
                    }}
                    columns={[
                        {
                            name: "Time",
                            options: {
                                customBodyRender: (val) => {
                                    const match = /(.+?)T(.+?)\./.exec(val)
                                    return <span style={{whiteSpace: "nowrap"}}>{match ? `${match[1]} ${match[2]}` : val}</span>
                                }
                            }
                        },
                        "Transaction",
                        "Type",
                        "Message",
                        {
                            name: "Diagnostics",
                            options: {
                                customBodyRender: (json) => <Box style={{
                                    maxHeight: 100,
                                    overflowY: 'auto'
                                }}>
                                    <pre style={{fontFamily: "monospace", whiteSpace: "pre-wrap", fontSize: "0.8em"}}>{JSON.stringify(json, null, 2)}</pre>
                                </Box>
                            }
                        }
                    ]}
                    sortOrder={{name: 'Time', direction: 'desc'}}
                    onEdit={() => {}}
                    onDelete={() => {}}
                />
            </Grid>
        </Grid>
    </ProgressOr>
}